module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day03_02_stay-413c117e3dee14e0bdf1cbee91429a7a.jpg";